import React from 'react';

import LanguageSelectorImpl from 'components/language-selector';
import { isMobile } from 'utils/environment';

export const FooterLanguageSelector: React.FC = () => {
  return isMobile() ? null : <LanguageSelectorImpl color={Styles.color.white} />;
};
